module.exports = __webpack_public_path__ + "img/page2.9ed244c6.png";